export const dsd_policy_framework = [
  {
    id: 1,
    name: 'national Youth Policy',
    summary: 'shortsummary/national Youth Policy.html',
    link: 'national Youth Policy.pdf',
    audio_en: 'audio/en/national Youth Policy_en.mp3',
    audio_af: 'audio/af/national Youth Policy_af.mp3',
    audio_xh: 'audio/xh/national Youth Policy_xh.mp3'
  },
  {
    id: 2,
    name: 'OneCape_2040',
    summary: 'shortsummary/OneCape_2040.html',
    link: 'OneCape_2040.pdf',
    audio_en: 'audio/en/OneCape_2040_en.mp3',
    audio_af: 'audio/af/OneCape_2040_af.mp3',
    audio_xh: 'audio/xh/OneCape_2040_xh.mp3'
  },
  {
    id: 3,
    name: 'White Paper for Social Welfare (1997)',
    summary: 'shortsummary/White Paper for Social Welfare (1997).html',
    link: 'White Paper for Social Welfare (1997).pdf',
    audio_en: 'audio/en/White Paper for Social Welfare (1997)_en.mp3',
    audio_af: 'audio/af/White Paper for Social Welfare (1997)_af.mp3',
    audio_xh: 'audio/xh/White Paper for Social Welfare (1997)_xh.mp3'
  }
];